export const project3Movie = {
  uuid: 'b2c3d4e5-f6a7-4890-b123-456789abcdef',
  date: '02 Apr 2025',
  readingTime: '7 min read',
  lead:
    'This page is a blog-style summary (easy to edit). The full PDF report is kept at the end.',
  sections: [
    {
      number: '01',
      label: 'Demo',
      heading: 'Demo (placeholder)',
      paragraphs: [
        'Demo text: describe an interactive notebook-style walkthrough (sample dataset → analysis → insights).',
      ],
      quote: {
        pill: 'DEMO',
        text: '“Filter, visualize, and explore key patterns quickly.”',
      },
    },
    {
      number: '02',
      label: 'Overview',
      heading: 'What this highlight covers',
      paragraphs: [
        'Summarize the dataset, feature engineering, models/analysis, and main insights.',
      ],
      bullets: [
        { bold: 'Data', text: 'where it came from and what it contains.' },
        { bold: 'Analysis', text: 'key transformations and techniques.' },
        { bold: 'Insights', text: 'top findings and conclusions.' },
      ],
    },
    {
      number: '03',
      label: 'Notes',
      heading: 'Key notes',
      paragraphs: [
        'Add limitations, assumptions, and next improvements here.',
      ],
    },
  ],
};

